// extracted by mini-css-extract-plugin
export default {"categorySelect":"EditMapPlacements_categorySelect__sxXUN","tilesGrid":"EditMapPlacements_tilesGrid__WXCtN","scaledContainer":"EditMapPlacements_scaledContainer__cgtMx"};